var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSagehr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9552 5C9.70867 5 8 6.71041 8 8.89593C8 11.3032 9.70867 12.2217 11.6072 12.7919C13.4108 13.362 14.2651 13.9955 14.2651 15.2308C14.2651 16.4977 13.3158 17.3846 12.0818 17.3846C10.8478 17.3846 9.77195 16.4977 9.77195 15.1357C9.77195 14.3756 10.12 14.1855 10.12 13.7738C10.1517 13.2986 9.80359 12.9186 9.26568 12.9186C8.63284 12.9186 8 13.8688 8 15.2308C8 17.4163 9.86687 19 12.0818 19C14.3284 19 16.0371 17.2896 16.0371 15.1041C16.0371 12.7285 14.3284 11.7783 12.3982 11.2081C10.6263 10.6697 9.77195 10.0045 9.77195 8.76923C9.77195 7.53394 10.6896 6.64706 11.9236 6.64706C13.1893 6.64706 14.2335 7.56561 14.2335 8.8009C14.2651 9.37104 14.6448 9.71946 15.1194 9.71946C15.5941 9.71946 16.0371 9.37104 16.0054 8.76923C16.0054 6.55204 14.1702 5 11.9552 5Z",
    fill: "#00D639"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSagehr);
export default __webpack_public_path__ + "static/media/sagehr.3c9a31c8ae8f1c384bbdbb5309d92673.svg";
export { ForwardRef as ReactComponent };